export default __webpack_public_path__ + "static/media/icon-feather-user-check.bd75b4ff.svg";